import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { SECTION } from 'utils/section'
import symbol from 'assets/img/symbol-white.svg'
import olliImage from 'assets/img/olli.png'
import akuImage from 'assets/img/aku.png'
import styles from './Contact.module.scss'

export const Contact = () => {
  const { t } = useTranslation()
  return (
    <section id={SECTION.CONTACT} className={styles['section']}>
      <div className={styles['container']}>
        <img className={styles['symbol']} src={symbol} alt="PreFor" />
        <h2>{ t('contact.title') }</h2>
        <p className={styles['text']}>
          {t('contact.description')}<br />
          <Trans i18nKey="contact.email">
            Email at <a className={styles['link']} href="mailto:info@prefor.fi">info@prefor.fi</a>
          </Trans>
        </p>
        <div className={styles['persons']}>
          <div className={styles['person']}>
            <img className={styles['photo']} src={olliImage} alt={t('contact.olli.name')} />
            <div className={styles['name']}>{t('contact.olli.name')}</div>
            <div className={styles['title']}>{t('contact.olli.title')}</div>
            <div className={styles['description']}>{t('contact.olli.description')}</div>
            <a className={styles['email']} href="mailto:{t('contact.olli.email')}">{t('contact.olli.email')}</a>
            <div className={styles['phone']}>{t('contact.olli.phone')}</div>
          </div>
          <div className={styles['person']}>
            <img className={styles['photo']} src={akuImage} alt={t('contact.aku.name')} />
            <div className={styles['name']}>{t('contact.aku.name')}</div>
            <div className={styles['title']}>{t('contact.aku.title')}</div>
            <div className={styles['description']}>{t('contact.aku.description')}</div>
            <a className={styles['email']} href="mailto:{t('contact.aku.email')}">{t('contact.aku.email')}</a>
            <div className={styles['phone']}>{t('contact.aku.phone')}</div>
          </div>
        </div>
      </div>
    </section>
  )
}
